export const HTTPS_URLS = /(https?:\/\/[^\s]+)/g;
export const REGEXP_SPACES = /\s/g;
export const REGEXP_SPACES_AND_SYMBOLS = /[ !@#$%^&*()\-=\[\]{};':"\\|,.<>\/?]/g;
